import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth-guard';
import { roleGuard } from './core/guards/role-guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.authRoutes)
  },
  {
    path: 'activar',
    loadComponent: () => import('./features/auth/activate-account/activate-account').then(m => m.ActivateAccount)
  },
  {
    // "¿Olvidaste tu contraseña?": se pide el link por correo.
    path: 'recuperar-contrasena',
    loadComponent: () => import('./features/auth/forgot-password/forgot-password').then(m => m.ForgotPassword)
  },
  {
    // Adonde lleva el link del correo. El backend arma esta ruta: cambiarla rompe los links.
    path: 'restablecer-contrasena',
    loadComponent: () => import('./features/auth/reset-password/reset-password').then(m => m.ResetPassword)
  },
  {
    // Adonde vuelve Encustody después de firmar. Fuera de las secciones por rol: llega
    // cualquiera que firme, el acreedor o un participante.
    path: 'firma/resultado',
    canActivate: [authGuard],
    loadComponent: () => import('./features/signing/signing-result/signing-result').then(m => m.SigningResult)
  },
  {
    path: 'lender',
    loadComponent: () => import('./layouts/lender/lender').then(m => m.LenderLayout),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['lender'] },
    loadChildren: () => import('./features/lender/lender.routes').then(m => m.lenderRoutes)
  },
  {
    path: 'dealer',
    loadComponent: () => import('./layouts/dealer/dealer').then(m => m.DealerLayout),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['dealer'] },
    loadChildren: () => import('./features/dealer/dealer.routes').then(m => m.dealerRoutes)
  },
  {
    path: 'debtor',
    loadComponent: () => import('./layouts/debtor/debtor').then(m => m.DebtorLayout),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['debtor'] },
    loadChildren: () => import('./features/debtor/debtor.routes').then(m => m.debtorRoutes)
  },
  {
    path: 'cosigner',
    loadComponent: () => import('./layouts/cosigner/cosigner').then(m => m.CosignerLayout),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['cosigner'] },
    loadChildren: () => import('./features/cosigner/cosigner.routes').then(m => m.cosignerRoutes)
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];
